export function clasificarMovimientoKardex(movimiento) {
  const documento = String(movimiento?.detalle || '').trim().toUpperCase();
  const esSalida = movimiento?.tipo === 1 || movimiento?.tipo === '1' || movimiento?.tipo === 'S';

  if (/^(GR|GI|GRI)(?:\s|$)/.test(documento)) {
    return { clase: 'traslado', etiqueta: 'Transporte', icono: '↔', esVenta: false };
  }

  if (esSalida && /^B/.test(documento)) {
    return { clase: 'venta', etiqueta: 'Boleta', icono: '↑', esVenta: true };
  }

  if (esSalida && /^F/.test(documento)) {
    return { clase: 'venta', etiqueta: 'Factura', icono: '↑', esVenta: true };
  }

  if (esSalida) {
    return { clase: 'salida', etiqueta: 'Salida', icono: '↑', esVenta: false };
  }

  return { clase: 'entrada', etiqueta: 'Compra', icono: '↓', esVenta: false };
}

function nombreTienda(nombre) {
  const limpio = String(nombre || '').replace(/\.$/, '').trim();
  const numero = limpio.match(/\b(939|1179|11155)\b/)?.[1];
  return numero ? `Lapoint ${numero}` : (limpio || 'Tienda');
}

function claveTraslado(detalle) {
  return String(detalle || '')
    .trim()
    .toUpperCase()
    .replace(/^(GRI|GR|GI)\s+/, '')
    .replace(/\s+/g, '');
}

export function rutaMovimientoKardex(movimiento, movimientos = []) {
  const info = clasificarMovimientoKardex(movimiento);
  const almacen = nombreTienda(movimiento?.almacen);

  if (info.clase === 'traslado') {
    const clave = claveTraslado(movimiento?.detalle);
    const relacionados = movimientos.filter((item) =>
      clasificarMovimientoKardex(item).clase === 'traslado' &&
      claveTraslado(item.detalle) === clave
    );
    const salida = relacionados.find((item) => Number(item.tipo) === 1);
    const ingreso = relacionados.find((item) => Number(item.tipo) === 0);
    const origen = salida ? nombreTienda(salida.almacen) : (Number(movimiento?.tipo) === 1 ? almacen : 'Otra tienda');
    const destino = ingreso ? nombreTienda(ingreso.almacen) : (Number(movimiento?.tipo) === 0 ? almacen : 'Otra tienda');
    return { origen, destino, texto: `${origen} → ${destino}` };
  }

  if (info.clase === 'entrada') {
    return { origen: 'Proveedor', destino: almacen, texto: `Proveedor → ${almacen}` };
  }
  if (info.esVenta) {
    return { origen: almacen, destino: 'Cliente', texto: `${almacen} → Cliente` };
  }
  return { origen: almacen, destino: 'Salida', texto: `${almacen} → Salida` };
}

export function contextoDocumentoKardex(movimiento) {
  const info = clasificarMovimientoKardex(movimiento);
  const documento = String(movimiento?.detalle || '').toUpperCase();
  if (info.clase === 'entrada' && /(^|\s)F[A-Z0-9]*[-\s]/.test(documento)) return 'Factura de ingreso';
  if (info.clase === 'entrada') return 'Documento de ingreso';
  if (info.clase === 'traslado') return Number(movimiento?.tipo) === 1 ? 'Salida de tienda' : 'Recepción en tienda';
  return info.etiqueta;
}
